import type { CacheMetrics } from '../value-objects/CacheMetrics';
import type { CacheEntry } from '../value-objects/CacheEntry';

const WARNING_THRESHOLD = 0.8;

export function shouldEvict(metrics: CacheMetrics, newEntrySizeMb: number): boolean {
  return metrics.currentMb + newEntrySizeMb > metrics.limitMb;
}

export function getEvictionCandidate(
  entries: ReadonlyMap<number, CacheEntry>,
  protectedFrames: Set<number>,
): number | null {
  let oldestAccess = Infinity;
  let candidate: number | null = null;

  for (const [frameId, entry] of entries) {
    if (protectedFrames.has(frameId)) continue;
    if (entry.lastAccess < oldestAccess) {
      oldestAccess = entry.lastAccess;
      candidate = frameId;
    }
  }

  return candidate;
}

export function getWindowFrames(currentFrame: number, total: number): number[] {
  const frames: number[] = [];
  if (currentFrame > 0) frames.push(currentFrame - 1);
  frames.push(currentFrame);
  if (currentFrame < total - 1) frames.push(currentFrame + 1);
  return frames;
}

export function shouldWarn(metrics: CacheMetrics): boolean {
  return metrics.currentMb / metrics.limitMb > WARNING_THRESHOLD;
}
